import React, { FC } from 'react';
import UtilFunctions from '~utils/functions';
import * as ChipStyles from './_chip.module.scss';

type ChipProps = {
    label: string,
    type?: 'success' | 'warning' | 'error' | 'inactive' | 'info',
    className?: string;
}

const Chip: FC<ChipProps> = ({
    label,
    type = 'success',
    className,
}) => {

    const chipStyles = UtilFunctions.Styles.concatClassNames([
        ChipStyles.container,
        (type ? ChipStyles[`${type}`] : ''),
        (className ? className : ''),
    ]);

    return (
        <div className={chipStyles}>
            {label}
        </div>
    );
};

export default Chip;
